<template>
    <v-container>
        <v-row>
            <v-col cols="12" sm="3">
                <ChooseOfWheels v-model="wheels" />
            </v-col>
            <v-col cols="12" sm="9">
                <v-card flat>
                    <v-overlay
                        v-if="tabs.length === 0"
                        absolute
                        color="#036358"
                    >
                       Выберете колесо
                    </v-overlay>
                    <v-tabs
                            v-model="tab"
                    >
                        <v-tab
                                v-for="item in tabs"
                                :key="item.key"
                                @click="isFirstTab = false"
                        >
                            <v-img :src="icon[item.icon]" aspect-ratio="2" contain class="tabs_icons"></v-img>
                        </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                        <v-tab-item
                                v-for="item in tabs"
                                :key="item.key"
                        >
                            <v-card flat class="main_bg_color">
                                <v-card-text class="pt-1 pb-0">
                                    <p class="subtitle-1 mb-0">Колеса</p>
                                    <wheelRadius :side="item.key" source="diskrepair"/>
                                    <diskRepairOptions :side="item.key" source="diskrepair" :hugeDamage="hugeDamage" :bigDamage="bigDamage"/>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="9" class="result-text">
                <p v-for="(item,index) in getTotalWheelsInfo(showActive)" :key="index">
                    {{ "[" + item.item.side + "] " + item.text }}
                </p>
            </v-col>
            <v-col cols="12" sm="3" class="pt-0">
                <div class="price mb-3">
                                            <span class="fullprice" v-if="discount>0">
                                                {{numberWithSpaces(totalPriceFull)}} ₽
                                            </span>
                    <span class="discount" v-if="discount>0">
                                                -{{ discount }}%
                                            </span>
                    <span class="discountprice">
                                                {{numberWithSpaces(totalPrice)}} ₽
                                            </span>
                </div>
                <v-btn data-test-id="addRepair" large color="#C8FA92" block @click="addServiceToCart">
                    Добавить
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    // @ is an alias to /src
    import ChooseOfWheels from './ChooseOfWheels'
    import wheelRadius from './wheelRadius'
    import diskRepairOptions from './diskrepair/diskRepairOptions'
    import {mapGetters} from 'vuex'



    export default {
        props: ['itemID'],
        components: {
            diskRepairOptions,
            ChooseOfWheels,
            wheelRadius,
        },
        computed: {
            ...mapGetters([
                "calcSubTypes",
            ]),
            steelID() {
                return this.calcSubTypes.find(x => x.calc_subtype == 'SteelDiskRepair' )
            },
            solidID() {
                return this.calcSubTypes.find(x => x.calc_subtype == 'CastDiskRepair' )
            },
            icon () {
                return this.$store.state.imgs.icon
            },
            DiscRepairPrice () {
                return this.$store.state[this.source].DiscRepairPrice
            },
            discount () {
                return 0 //(this.$store.state.clientIdentify.client.discount.value + this.$store.state.clientIdentify.client.additional_discount.value) * 100
            },
            showActive () {
                let active = []
                const wheelsName = [ 'forwardLeft', 'forwardRight', 'backLeft', 'backRight', 'spareLeft', 'spareRight' ]
                const wheelsNameRus = [ 'Переднее левое', 'Переднее правое', 'Заднее левое', 'Заднее правое', 'Запасное левое', 'Запасное правое' ]
                wheelsName.forEach((key,index) => {
                    if (this.$store.state[this.source].wheels[key] && this.$store.state[this.source].wheels[key].isActive) {
                        active.push({name: wheelsNameRus[index], data: this.$store.state[this.source].wheels[key]})
                    }
                })
                return active
            },
            tabs() {
                let res = [];
                const icons = ['fl', 'fr', 'bl', 'br', 'sl', 'sr'];
                let i = 0;
                for (const key in this.wheels) {
                    if (this.wheels[key]) {
                        res.push({key: key, icon: icons[i], slot: icons[i]})
                    }
                    i++;
                }
                return res
            },
            QRcodeUrl() {
                return this.$store.state.repair.QRcodeUrl
            },
            isFirstTab: {
                get() {
                    return this.$store.state[this.source].isFirstTab
                },
                set(value) {
                    this.$store.commit(this.source + '/setIsFirstTab', value )
                }
            },
            wheels: {
                get() {
                    return {
                        forwardLeft: this.$store.state[this.source].wheels.forwardLeft.isActive,
                        forwardRight: this.$store.state[this.source].wheels.forwardRight.isActive,
                        backLeft: this.$store.state[this.source].wheels.backLeft.isActive,
                        backRight: this.$store.state[this.source].wheels.backRight.isActive,
                        spareLeft: this.$store.state[this.source].wheels.spareLeft.isActive,
                        spareRight: this.$store.state[this.source].wheels.spareRight.isActive
                    }
                },
                set(value) {
                    this.$store.dispatch(this.source + '/changeActiveWheels', value)
                }
            }

        },
        data () {
            return {
                quantity:null,
                hugeDamage:500,
                bigDamage:300,
                allValues: [],
                source: 'diskrepair',
                paintType: 0,
                paintTypeList1: [
                    {id: 0, title: 'Порошковая'},
                    {id: 1, title: 'Акриловая'},
                    {id: 2, title: 'Покрыть лаком'},
                    {id: 3, title: 'Диско крас'},
                ],
                showInfo: false,
                totalPrice: null,
                totalPriceFull: null,
                resultText: 'Ремонт бокового пореза шины размером 3х5 мм, заплатка «Стандарт» с применением горячей вулканизации с восстановлением защитной кромки',
                tab: null,
                panel: 0,
                title: 'Ремонт дисков',
                myInputModel: '',
                dropped: true,
            }
        },
        methods: {
            async addServiceToCart() {
                let service = this.$store.getters.services[this.itemID]
                service.addText = this.allValues
                for (let i=0; i < this.allValues.length; i++) {
                  const x = this.allValues[i]
                  await this.$store.dispatch('addServiceToCart', {
                    'service': service,
                    'id': x.item.serviceID,
                    'client': this.$store.getters.client ,
                    'quantity': x.item.quantity,
                    'description': '[' + x.item.side + '] ' + x.text,
                    'params': {
                      text: '[' + x.item.side + '] ' + x.text,
                      content: x,
                      diskType: x.item.solidDisk ? 'Литой диск' : 'Штампованый диск',
                      diskR: 'R' + x.item.radius,
                      carType: x.item.carType,
                      wheelSide: x.item.name,
                      isRunflat: x.item.isRunflat,
                      eightRepair: x.item.eightRepair,
                      edgeRepair: x.item.edgeRepair,
                      manualRepair: x.item.addRepair,
                      description: x.item.solidDisk ? 'Литой диск' + ' R' + x.item.radius : 'Штампованый диск' + ' R' + x.item.radius
                    },
                    'price': x.price
                  })
                }
            },
            numberWithSpaces(x) {
                if (x) {
                    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                }
            },
            infoClick(){
                this.showInfo = !this.showInfo
                console.log('infotext')
            },
            getTotalWheelsInfo (value) {
                console.log('getTotalWheelsInfo', value)
                let allValues = []
                let totalPrice = 0
                const DiscRepairPrice = this.$store.state[this.source].DiscRepairPrice
                value.forEach((x) => {
                    const name = x.name
                    x = x.data.data
                    x.side = this.shortSidename(name)
                    x.name = name
                    const radtext = x.radius?'R' + x.radius+' ':''
                    let text = radtext
                    let price = 0
                    let replica = false
                    let type = null
                    if (x.solidDisk){
                        x.serviceID = this.solidID.id || this.itemID
                        switch(x.diskClass){
                            case 0:
                                type = 1
                                text = text + 'Ремонт литого диска'
                                break
                            case 1:
                                type = 1
                                text = text + 'Ремонт литого диска реплика'
                                replica = true
                                break
                            case 2:
                                text = text + 'Ремонт кованного диска'
                                type = 2
                                break
                        }
                    } else {
                        text = text + 'Ремонт диска'
                        x.serviceID = this.steelID.id || this.itemID
                        type = 0
                    }
                    if (DiscRepairPrice[type] && type > 0) {
                        price = parseInt(DiscRepairPrice[type].repairs.find(v=>v.radius==x.radius).price)
                    }
                    let count = 0
                    if (x.premium && type === 1) {
                        text = text + ' премиум '
                        price = price + DiscRepairPrice[type].options[3].price
                    } else if (x.premium && type === 2) {
                        text = text + ' премиум '
                        price = price + DiscRepairPrice[type].options[2].price
                    }
                    if(x.solidDisk){
                        x.diskDamage.forEach((v)=>{
                            if(v.active){
                                count++
                                if(count>1){
                                    text = text + ', '
                                    price = price + DiscRepairPrice[type].options[1].price
                                }
                                const side = v.inside?' внутри ':' снаружи '
                                text = text + ', повреждение ' + side + v.size + ' мм.'
                                if (v.size > 2) {

                                    if (v.size > 4) {
                                        const hugeDamage = DiscRepairPrice[type].options.filter(x => x.name === 'Очень крупное повреждение')
                                        this.hugeDamage = hugeDamage[0]
                                        price = price + this.hugeDamage.price //DiscRepairPrice[type].options[1].price
                                    } else {
                                        const bigDamage = DiscRepairPrice[type].options.filter(x => x.name === 'Крупное повреждение')
                                        this.bigDamage = bigDamage[0]
                                        price = price + this.bigDamage.price //DiscRepairPrice[type].options[1].price
                                    }
                                }
                            }
                        })
                    } else {
                        if (x.edgeRepair) {
                            text = text + ', ремонт кромки диска'
                            price = price + DiscRepairPrice[type].options[2].price
                        }
                        price = price + parseInt(DiscRepairPrice[type].repairs.find(v=>v.radius==x.radius).price)
                        if (x.addRepair) {
                            if (x.addRepairNumbr >= 1) {
                                price = price + DiscRepairPrice[type].options[1].price * x.addRepairNumbr
                            }
                            text = text + ', Ручной ремонт,' + x.addRepairNumbr + ' шт'
                        }
                    }
                    if (x.eightRepair) {
                        text = text + ', ремонт восьмерки.'
                        price = price + DiscRepairPrice[type].options[0].price
                    } else {
                        text = text + '.'
                    }
                    if (replica) price = price + DiscRepairPrice[type].options[2].price
                    totalPrice = totalPrice + price
                    if (price==0) { text='' }
                    if (allValues.length > 0) {
                        const i = allValues.findIndex(val => val.text == text);
                        if (i >= 0) {
                            x.side = allValues[i].item.side + "," + x.side;
                            x.quantity = allValues[i].item.quantity + 1;
                            allValues.splice(i, 1, {
                                text,
                                item: x,
                                price: allValues[i].price
                            });
                        } else {
                            x.quantity = 1;
                            allValues.push({ text, item: x, price: price });
                        }
                    } else {
                        x.quantity = 1;
                        allValues.push({ text, item: x, price: price });
                    }
                    // if ( text != '') {
                    //     const valueToAdd = { text, price, item: x }
                    //     allValues.push(valueToAdd)
                    // }
                })
                this.totalPrice = Math.round(totalPrice - totalPrice / 100 * this.discount)
                this.totalPriceFull = Math.round(totalPrice)
                this.$store.commit('updateServicesPrice', [this.itemID ,this.totalPriceFull])
                this.allValues = allValues
                return allValues
            },
            shortSidename(sideName) {
                const wheelsName = ["ПЛ", "ПП", "ЗЛ", "ЗП", "ЗАП1", "ЗАП2"];
                const wheelsNameRus = [
                    "Переднее левое",
                    "Переднее правое",
                    "Заднее левое",
                    "Заднее правое",
                    "Запасное левое",
                    "Запасное правое"
                ];
                let index = wheelsNameRus.findIndex(x => x == sideName);
                return wheelsName[index];
            },
            onTabChange () {
                if(this.isFirstTab) {
                    this.$store.dispatch('copySide', this.tabs[0].slot)
                }
                this.$store.commit('diskrepair/setIsFirstTab', false)
                this.isFirstTab = false;
            }
        },
        created() {
            this.$store.dispatch('diskrepair/init')
            this.isFirstTab = true
        }
    }
</script>
